<template>
  <v-card>
    <v-card-title class="text-h6 mb-4"> Warnings for {{ typeName }} </v-card-title>
    <v-card-text v-if="warnings" class="text-body-1">
      <!-- Messages section -->
      <v-simple-table v-if="has('messages')" dense class="mb-4">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">Messages</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(message, index) in warnings.messages.l" :key="index">
              <td>{{ message.msg }}</td>
            </tr>
            <tr v-if="warnings.messages.more > 0">
              <td>{{ warnings.messages.more }} more messages</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <!-- Solver Errors section -->
      <v-simple-table v-if="has('solverErrors')" dense class="mb-4">
        <template v-slot:default>
          <thead>
            <tr>
              <th>Problem</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(warning, index) in warnings.solverErrors.l" :key="index">
              <td>{{ warning.probName }}</td>
              <td>{{ warning.msg }}</td>
            </tr>
            <tr v-if="warnings.solverErrors.more > 0">
              <td colspan="2">{{ warnings.solverErrors.more }} more solver errors</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <!-- Infeasible Constraints section -->
      <v-simple-table v-if="has('infeasibleConstraints')" dense class="mb-4">
        <template v-slot:default>
          <thead>
            <tr>
              <th>Problem</th>
              <th>Infeasible Constraint</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(constraint, index) in warnings.infeasibleConstraints.l" :key="index">
              <td>{{ constraint.probName }}</td>
              <td>
                <details>
                  <summary>{{ constraint.constraint }}</summary>
                  Variables involved:
                  <ul class="pa-0">
                    <li v-for="(variable, varIndex) in constraint.variables.l" :key="varIndex">
                      {{ variable }}
                    </li>
                  </ul>
                  <div v-if="constraint.variables.more > 0">
                    And {{ constraint.variables.more }} more variables
                  </div>
                </details>
              </td>
            </tr>
            <tr v-if="warnings.infeasibleConstraints.more > 0">
              <td colspan="100%">
                {{ warnings.infeasibleConstraints.more }} more infeasible constraints
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <!-- Suspicious Results section -->
      <v-simple-table v-if="has('suspiciousResults')" dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th>Message</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(issue, index) in warnings.suspiciousResults.l" :key="index">
              <td>{{ issue.msg }}</td>
              <td>
                <details>
                  <summary>{{ issue.value }} {{ issue.unit }}</summary>
                  Expected value around {{ Math.round(issue.interval[0]) }} and
                  {{ Math.round(issue.interval[1]) }} ({{ issue.reference }}).
                </details>
              </td>
            </tr>
            <tr v-if="warnings.suspiciousResults.more > 0">
              <td colspan="2">{{ warnings.suspiciousResults.more }} more suspicious results</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-text v-else> No warnings </v-card-text>
    <v-card-actions>
      <v-btn @click="$emit('close')" text color="red darken-1"> Cancel </v-btn>
      <v-spacer />
      <v-btn color="primary" text @click="handleReRun"> Run again </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "WarningsDialog",
  props: {
    type: {
      type: Number,
      required: true,
    },
    typeName: {
      type: String,
      required: true,
    },
    warnings: {
      type: Object,
      required: false,
      default: null,
    },
  },
  methods: {
    handleReRun() {
      this.$emit("re-run", this.type);
      this.$emit("close");
    },
    has(warningKind) {
      return this.warnings[warningKind] && this.warnings[warningKind].l.length > 0;
    },
  },
};
</script>
